
export const SafioVersion: string = process.env.VUE_APP_VERSION!
